@if (hasPublishedItems()) {
<rds-divider class="divider"></rds-divider>
<div class="learning-resources">
  <h2 class="ui-heading-2-bold learning-resources-title">
    {{ OFFERING_TEXT.OFFERINGS.LEARNING_RESOURCE_SECTION.SECTION_TITLE }}
  </h2>

  <ul class="learning-resources-content">
    @for(l of learningResources(); track $index) {
      @if(l.published === true) {
      <li class="learning-resource-item">
        <a rds-link standalone href="{{ l.url }}" target="_blank">
          {{ l.title }}
          <rds-icon namespace="filled" icon="arrow_right" />
        </a>
      </li>
      }
    }
  </ul>
</div>
}
